import { useCallback, useState } from 'react';
import { useLegacyAuthGatewayFetch } from '@penta/penta-api';
import { useClient } from '../contexts/ClientContext';

const REDIRECT_DELAY_MS = 2000;

export const useRedirectToOldIb = () => {
  const legacyApi = useLegacyAuthGatewayFetch();
  const { selectedClientId } = useClient();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const redirect = useCallback(
    async (pageIdentifier: string, productId?: number) => {
      if (selectedClientId == null) {
        console.error('[OldIB] No client ID available for redirect');
        return;
      }

      setIsRedirecting(true);

      try {
        const { data, error } = await legacyApi.POST('/v1/url', {
          body: {
            pageIdentifier,
            clientId: String(selectedClientId),
            ...(productId !== undefined ? { productId } : {}),
          },
        });

        if (error || !data) {
          console.error('[OldIB] Failed to get redirect URL', error);
          setIsRedirecting(false);
          return;
        }

        await new Promise((resolve) => setTimeout(resolve, REDIRECT_DELAY_MS));
        window.location.href = `${data.url}?code=${data.code}`;
      } catch (err) {
        console.error('[OldIB] Unexpected error during redirect', err);
        setIsRedirecting(false);
      }
    },
    [legacyApi, selectedClientId],
  );

  return { redirect, isRedirecting };
};
